export class FlukePool {
  constructor (data) {
    this.natures = []
    if (typeof data === 'object') {
      if (data instanceof Array) { this.data = data } else {
        this.data = data
        this.natures = this.getNatures(data)
      }
    }
  }

  getNatures (data) {
    const fn = function (data, parent) {
      let natures = []
      if (data instanceof Array === false) {
        Object.keys(data).forEach((k) => {
          const accesspath = (parent ? parent + '.' : '') + k
          if (data[k] instanceof Array) {
            natures.push({path: accesspath, pointer: data[k]})
          } else {
            natures.push({path: accesspath})
            const localnatures = fn(data[k], accesspath)
            natures = natures.concat(localnatures)
          }
        })
      }
      return natures
    }

    const allPaths = fn(data)
    const natures = []
    allPaths.forEach((a) => {
      let path = a.pointer ? a.path : ''
      if (path) natures.push({path: '.' + a.path + '.', pointer: a.pointer})
    })

    return natures
  }

  getDataPointersByNature (natures) {
    if (!natures) return this.natures
    const reqNatures = natures.split(',')
    const matchingPointers = []
    this.natures.forEach((n) => {
      let allMatch = true
      reqNatures.forEach((r) => {
        if (n.path.indexOf('.' + r + '.') === -1) allMatch = false
      })
      if (allMatch) matchingPointers.push(n)
    })

    return matchingPointers
  }
}



// WEBPACK FOOTER //
// ./src/flukePool.js